<div class="side-bar" [ngClass]="{ 'is-active': status$ | async }">
  <div class="header">
    <div class="container">
      <div class="content">
        <a class="logo" [routerLink]="''" (click)="close()">
          <cx-abstract [component]="components | cmsComponent: CX_COMPONENT.LOGO" />
        </a>
        <icon-hamburguer></icon-hamburguer>
      </div>
    </div>
  </div>

  <div class="body">
    <ul class="body__list">
      <li *ngIf="b2bUnit$ | async as b2bUnit">
        <div class="body__list--menu-header">
          <span class="body__list--menu-title">{{ 'selectB2BUnitModal.b2bUnit.label' | translate }}</span>
          <span class="body__list--menu-subtitle">{{ b2bUnit.name }}</span>
        </div>
        <cx-abstract [component]="components | cmsComponent: CX_COMPONENT.AUXILIARY_LINKS" />
      </li>

      <li>
        <div class="body__list--menu-header">
          <span class="body__list--menu-title">Categorias Principais</span>
        </div>
        <cx-abstract [component]="components | cmsComponent: CX_COMPONENT.MAIN_NAVIGATION_BAR" />
      </li>

      <li>
        <div class="body__list--menu-header" *ngIf="user$ | async as user">
          <span class="body__list--menu-title">{{ 'user.profile' | translate }}</span>
          <span class="body__list--menu-subtitle"> {{ user.firstName }} {{ user.lastName }} | Usuário: {{ user.username }} </span>
          <span class="body__list--menu-subtitle">{{ user.email }}</span>
        </div>
        <cx-abstract [component]="components | cmsComponent: CX_COMPONENT.PROFILE_LINKS" />
      </li>
    </ul>
  </div>
</div>
